// Keep this object in sync with the analogous backend one in lib/terminal/sample_locations.rb
export const locales = {
  IE: {
    location: {
      displayName: 'HQ',
      address: {
        line1: 'Grand Canal Street Lower',
        city: 'Dublin',
        country: 'IE',
        postalCode: 'D02 H210',
      },
    },
    currency: 'eur',
  },
  NL: {
    location: {
      displayName: 'HQ',
      address: {
        line1: 'Singel 542',
        city: 'Amsterdam',
        country: 'NL',
        postalCode: '1017 AZ',
      },
    },
    currency: 'eur',
  },
  DE: {
    location: {
      displayName: 'HQ',
      address: {
        line1: 'Stresemannstraße 123',
        city: 'Berlin',
        country: 'DE',
        postalCode: '10963',
      },
    },
    currency: 'eur',
  },
  FR: {
    location: {
      displayName: 'HQ',
      address: {
        line1: '10 Boulevard Haussmann',
        city: 'Paris',
        country: 'FR',
        postalCode: '75009',
      },
    },
    currency: 'eur',
  },
  NZ: {
    location: {
      displayName: 'HQ',
      address: {
        line1: '203 Victoria Street',
        city: 'Auckland Central',
        state: 'Auckland',
        country: 'NZ',
        postalCode: '1010',
      },
    },
    currency: 'eur',
  },
  AU: {
    location: {
      displayName: 'HQ',
      address: {
        line1: '1234 Victoria Street',
        city: 'Melbourne',
        state: 'Victoria',
        country: 'AU',
        postalCode: '3000',
      },
    },
    currency: 'aud',
  },
  CA: {
    location: {
      displayName: 'HQ',
      address: {
        line1: '3040 Bur Oak Ave',
        city: 'Markham',
        state: 'ON',
        country: 'CA',
        postalCode: 'L6B 0R1',
      },
    },
    currency: 'cad',
  },
  SG: {
    location: {
      displayName: 'HQ',
      address: {
        line1: '19 Keppel Road',
        city: 'Singapore',
        state: '',
        country: 'SG',
        postalCode: '089058',
      },
    },
    currency: 'sgd',
  },
  US: {
    location: {
      displayName: 'HQ',
      address: {
        line1: '1272 Valencia Street',
        city: 'San Francisco',
        state: 'CA',
        country: 'US',
        postalCode: '94110',
      },
    },
    currency: 'usd',
  },
  GB: {
    location: {
      displayName: 'HQ',
      address: {
        line1: '448A Crownhill Rd',
        city: 'Plymouth',
        country: 'GB',
        postalCode: 'PL5 2QT',
      },
    },
    currency: 'gbp',
  },
};
